import { render, staticRenderFns } from "./app-recruiting-desk.vue?vue&type=template&id=58cee8ee&"
import script from "./app-recruiting-desk.vue?vue&type=script&lang=js&"
export * from "./app-recruiting-desk.vue?vue&type=script&lang=js&"
import style0 from "./app-recruiting-desk.vue?vue&type=style&index=0&id=58cee8ee&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports